import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const passwordMatchValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const password1 = control.get('newPassword1');
  const password2 = control.get('newPassword2');

  return password1 && password2 && password1.value != password2.value ? { 'passwordMatch': true } : null
}

@Component({
  selector: 'app-change-password-token',
  templateUrl: './change-password-token.component.html',
  styleUrls: ['./change-password-token.component.css']
})
export class ChangePasswordTokenComponent implements OnInit {

  token = ''

  passwordGroup: FormGroup

  constructor( private authService: AuthService, private _notification: MatSnackBar, private route: ActivatedRoute, private router: Router ) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        if(params.token) {
          this.token = params.token
        }
      });
      this.passwordGroup  = new FormGroup({
        'newPassword1': new FormControl('', [Validators.required, Validators.minLength(8)]),
        'newPassword2': new FormControl('', [Validators.required]),
      }, { validators: passwordMatchValidator })
  
    }
  
    onFormSubmit(form){  
      this.authService.changePasswordWithToken(form.newPassword1, this.token).subscribe(data => {
        if(data.status){
          Object.keys(this.passwordGroup.controls).forEach(key => {
            this.passwordGroup.get(key).setErrors(null) ;
          });
          this.router.navigate(['login'])
          this.openNotification('Password has been changed! Please login to continue')
        }
      }, error => {
        if(error.status == 400){
          if(error.error.message){
            this.openNotification(error.error.message)
          }else if(error.error.msg){
            this.openNotification(error.error.msg)
          } 
          
        }
      })
    } 
  
    openNotification(msg){
      this._notification.open(msg, 'Cancel', {
        duration: 2000,
        horizontalPosition: 'right'
      })
    }

}
